module.exports = __webpack_public_path__ + "static/img/__9059.32113a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9059.jpg
// module id = X+rl
// module chunks = 0